import React, { useEffect, useRef, useState } from 'react';
import { OnboardingStageProps, SetLoading } from '../../Classes';
import { Button, Field, Header, Icon, Message, Toast } from 'react-frontier';
import UploadBox from '../../components/UploadBox';
import API from '../../API';

var OnboardingDocuments = (props: OnboardingStageProps)=>{
	var [errorPrompts, setErrorPrompts] = useState<string>(null);
	var [files, setFiles] = useState<{
		id: File,
		address: File,
	}>({ id: null, address: null });

	var onFile = (file_type: keyof (typeof files))=>{
		return (file: File)=>{
			setFiles({
				...files,
				[file_type]: file
			});
		}
	}
	
	var sendInfo = (setLoading: SetLoading)=>{
		if(!files.id && !files.address && props.user.images.id && props.user.images.address){
			return props.onFinish();
		}
		if(!files.id && !files.address) return Toast.error('Favor de subir todos los archivos solicitados.');

		setLoading(true);
		API.onboardingUserFiles(files.id, files.address).then(res=>{
			if(res.error) return setErrorPrompts(res.message);
			props.onFinish();
		}).catch(err=>{
			setErrorPrompts('Hubo un error inesperado subiendo los archivos (LCL-ONBRFL-1)');
		}).finally(()=>{
			setLoading(false);
		})
	}

	var has_id = !!files.id || props.user.images.id;
	var has_address = !!files.address || props.user.images.address;

	return <div className="tp onboarding-documents">
		<Header text={'Documentos'} subtext={'Tus documentos de identificación'} />
		<Message centered style={{ marginBottom: 15 }}>
			A continuación subirás tus documentos de identificación asi como tu comprobante de domicilio.
			Te recordamos que esos documentos solamente los usamos para validarte y serán guardados de la manera mas segura.
		</Message>

		<Field label='Identificación' comment='Adjunta una imagen de tu identificación oficial (INE, pasaporte)'>
			<UploadBox
				icon={has_id ? 'check-circle' : 'image'}
				type={has_id ? 'green' : 'normal'}
				text={files.id?.name}
				maxFileSize={2.5*1024*1024}
				onFile={onFile('id')}
			/>
		</Field>

		<Field label='Comprobante de domicilio' comment='Adjunta una imagen del comprobante de domicilio, este debe de ser el mismo domicilio que ingresaste en la sección anterior'>
			<UploadBox
				icon={has_address ? 'check-circle' : 'image'}
				type={has_address ? 'green' : 'normal'}
				text={files.address?.name}
				maxFileSize={2.5*1024*1024}
				onFile={onFile('address')}
			/>
		</Field>
		{!!errorPrompts && (
			<Message type='error' list={[errorPrompts]} />
		)}
		<div className="actions">
			<Button disabled={!has_id || !has_address} color='black' text='Continuar' onClick={sendInfo} />
		</div>
	</div>
}

export default OnboardingDocuments;